import { default as checkoutCession } from './cession';

export const cession = {
  ...checkoutCession,
};
